module.exports = __webpack_public_path__ + "static/media/6.cd1b0810.jpg";